import { Step } from "react-joyride";
import { Tours, TourConfig } from "@common";
import { AppState } from "@store";
import { FetchingState } from "rd-redux-http";

export function getTourSteps(
    appState: AppState,
    tour: Tours
):
    | {
          steps: Step[];
          show: boolean;
      }
    | undefined {
    const tours = FetchingState.getDataOrDefault(appState.tours, {});
    const steps = getTourStepsFromTourConfig(tours, tour);
    const viewedTours = localStorage.getItem(TOURS_LOCAL_STORAGE_KEY)
        ? JSON.parse(localStorage.getItem(TOURS_LOCAL_STORAGE_KEY))
        : [];

    return {
        steps,
        show: viewedTours.indexOf(tour) === -1
    };
}

export const TOURS_LOCAL_STORAGE_KEY = "acc.viewed-tours";

function getTourStepsFromTourConfig(tourConfig: TourConfig, tour: Tours): Step[] {
    const configSteps = tourConfig[tour] || [];

    return configSteps.map(
        s =>
            ({
                content: s.content,
                target: s.target,
                disableBeacon: true
            } as Step)
    );
}
